import React from "react";
import PropTypes from "prop-types";

/**
 * @param {Select.propTypes} props
 */
export const Select = (props) => {
	return (
		<select
			className={[
				"text-black border border-solid rounded-sm hover:text-black bg-transparent focus:outline-none focus:shadow-none px-3 py-1 w-full max-w-none",
				"focus:border-" + props.color,
				"border-" + props.color,
			].join(" ")}
			onChange={(event) => props.onChange(event.target.value)}
			value={props.value}
		>
			{props.options.map((option, index) => (
				<option key={index} value={option.value} hidden={option.hidden}>
					{option.label}
				</option>
			))}
		</select>
	);
};

Select.defaultProps = {
	options: [],
	color: "border-black",
};

Select.propTypes = {
	value: PropTypes.any,
	options: PropTypes.array,
	onChange: PropTypes.func,
	/**
	 * Select border and text color class.
	 * Available options: plugin-1, plugin-2, plugin-3
	 */
	color: PropTypes.string,
};
